import React, {useEffect} from 'react';
import {Button, Result} from "antd";
import {useParams} from "react-router";
import {api} from "../core/api";


const ResultPage = () =>{
  let params = useParams() as {calc:any, result:any, pdf: any};

useEffect(()=>{
  params.result==="success" && confirmPayment();
// eslint-disable-next-line react-hooks/exhaustive-deps
},[]);

  async function confirmPayment(){
    await api.payment.confirm(params.calc)
  }
console.log(params);
  return (
  <>
    <div style={{backgroundColor: "white"}}>
      {params.result==="success" &&
        <Result
          status="success"
          title="Uspješno ste kupili polisu!"
          subTitle="Ovo je jednokratni link. Ukoliko napustite stranicu više ne možete preuzeti polisu.
           Ukoliko imate problema sa preuzimanjem polise možete se obratiti na broj telefona 020 404 404 ili putem maila
           info@lo.co.me"
          extra={[
            <Button type="primary" key="console" href={`https://prodaja.lo.co.me/mps_api/download?pdf=${params.pdf}`}>
              Preuzmi polisu
            </Button>,
            <Button key="buy" href={"https://prodaja.lo.co.me"}>Na početnu</Button>,
          ]}
        />
      }
      {params.result==="cancel" &&
        <Result
          status="warning"
          title="ODustali ste od kupovine."
          extra={
            <Button type="primary" key="console" href={"https://prodaja.lo.co.me"}>
              Na početnu
            </Button>
          }
        />
      }
      { params.result === "failed" &&
        <Result
          status="error"
          title="Neuspješno!"
          subTitle="Plaćanje nije uspjelo."
          extra={[
            <Button type="primary" key="console" href={"https://prodaja.lo.co.me"}>
              Na početnu
            </Button>,
            <Button key="buy" href={"/"}>Pokušaj ponovo</Button>,
          ]}
        >
        </Result>
      }
    </div>

  </>
)
};

export default ResultPage;
